import { h, ComponentChildren, createContext } from 'preact'; /** @jsx h */
import { useContext } from 'preact/hooks';

declare let window: any;
declare let process: any;

export type IEnvironmentProps = {
    children?: ComponentChildren;

    domain?: string | null;

    subdomain?: string;

    devSubdomain?: string;

    apis?: any;

    nodeEnv?: string;

    dataUrl?: string | null;
};

export type IEnvironment = {
    subdomain: string | undefined;
    isDevelopment: boolean;
    isBrowser: boolean;
    dataUrl: string;
    imageUrl: string;
    baseUrl: string;
    [key: string]: string | undefined;
}

const EnvironmentContext = createContext<IEnvironment | null>(null);

export const Environment = (props: IEnvironmentProps) => {
    const value = (function () {
        
        const objApis =
            props.apis !== undefined
                ? Object.keys(props.apis).reduce(
                        (result, key: string) => ({ ...result, [key]: `http://${props.apis?.[key]}`})
                    , {})
                : {};

        try {
            // we try to get the data from the window object
            const isDevelopment =
                props.nodeEnv?.localeCompare('development') === 0;

            
            const subdomain = (function () {
                if (isDevelopment) {
                    return props.devSubdomain;
                }
                const { hostname } = window.location;
                const subdomain = hostname
                    .split('.')
                    .slice(0, -2)
                    .join('_');
                const maindomain = hostname
                    .split('.')
                    .slice(-2, -1)[0];

                if (subdomain.length == 0 || subdomain.localeCompare('www') == 0) {
                    return maindomain;
                }

                if (maindomain.localeCompare('pyqml') == 0) {
                    return subdomain;
                }

                //console.log("Can't process subdomain", subdomain, maindomain);
                return maindomain;
            })()

            //console.log(window.location, props.domain, subdomain);

            const isBrowser = typeof window == "object" ?? false;
            // && window?.__NODE_ENV__?.localeCompare('development') === 0;

            // console.log(isBrowser)
            // from here on, we're sure in the browser
            return {
                /** during development, we use a fixed subdomain */
                subdomain: subdomain,
                isDevelopment,

                isBrowser,

                // this is the address of the API, also look at AuthProvider!
                dataUrl: props.dataUrl ? props.dataUrl : (isDevelopment ? `http://${props.domain}` : ''),
                ...objApis,

                imageUrl: isDevelopment ? `http://${props.domain}:8160/${subdomain}` : `https://www.${props.domain}/${subdomain}`,
                baseUrl: isDevelopment ? `http://${props.domain}:8160` : `https://www.${props.domain}`
            };
        } catch {
            // this is the server-side code
            const isDevelopment =
                typeof process &&
                process?.env?.NODE_ENV?.localeCompare('development') === 0;

            return {
                subdomain: props.subdomain,
                isDevelopment,
                // at the server, we need to work with absolute URLs
                dataUrl:  props.dataUrl ? props.dataUrl : (isDevelopment
                    ? `http://${props.domain}`
                    : `https://${props.subdomain}.${props.domain}`),
                isBrowser: false,
                // pyApi: `http://${props.pyApi}`
                ...objApis,

                imageUrl: isDevelopment ? `http://${props.domain}:8160/${props.subdomain}` : `https://www.${props.domain}/${props.subdomain}`,
                baseUrl: isDevelopment ? `http://${props.domain}:8160` : `https://www.${props.domain}`
            };
        }
    })();

    if (value.isDevelopment) {
        console.log('Environment', value);
    }

    return (
        <EnvironmentContext.Provider value={value}>
            {props.children}
        </EnvironmentContext.Provider>
    );
}

export const useEnvironment: any = () => {
    return useContext(EnvironmentContext);
};